import { render, staticRenderFns } from "./StdRiskText.vue?vue&type=template&id=390815ed&"
import script from "./StdRiskText.vue?vue&type=script&lang=js&"
export * from "./StdRiskText.vue?vue&type=script&lang=js&"
import style0 from "./StdRiskText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdRiskText.vue"
export default component.exports